import Color from '@/Enums/Color.enum';
import { Checkbox, Chip, chipClasses } from '@mui/material';
import { type ElementType, type ReactElement, memo } from 'react';

interface IMapItemButtonProps {
  label: string;
  Icon: ElementType;
  [key: string]: any;
}

const iconClassname = 'w-4 mr-1 p-0';

const MapItemButton = ({ label, Icon, ...props }: IMapItemButtonProps) => {
  return (
    <Checkbox
      sx={{ padding: 0 }}
      disableRipple
      checkedIcon={
        <MapItemChip
          label={label}
          Icon={Icon ? <Icon className={iconClassname} fill={Color.Primary} /> : null}
          checked
        />
      }
      icon={<MapItemChip label={label} Icon={Icon ? <Icon className={iconClassname} /> : null} />}
      inputProps={{ 'aria-label': label }}
      {...props}
    />
  );
};

interface IMapItemChipProps {
  checked?: boolean;
  Icon: ReactElement | null;
  label: string;
}

const MapItemChip = memo(({ checked, Icon, label }: IMapItemChipProps) => {
  const style = checked
    ? {
        border: `1px solid ${Color.Primary}`,
        backgroundColor: Color.PrimaryBackgroundTransparent,
        color: Color.Primary,
      }
    : {
        border: `1px solid ${Color.GreyBorder}`,
        backgroundColor: 'transparent',
        color: Color.Grey,
      };
  return (
    <Chip
      sx={{
        borderRadius: '4px',
        fontWeight: 600,
        fontSize: '13px',
        padding: '8px 0',
        [`& .${chipClasses.label}`]: {
          display: 'flex',
          alignItems: 'center',
        },
        ...style,
      }}
      label={
        <>
          {Icon}
          <span>{label}</span>
        </>
      }
    />
  );
});

export default MapItemButton;
